import { styled } from "@mui/material/styles";

const StyledProducts = styled("div")(
  ({ theme }) => `  
  padding: 0 6%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 42px;

  .product-count {
    font-family: Lexend;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: ${theme.palette.customColor.secondarySecond};
    margin-top: 10px;
  }

  .lexend-text {
    font-family: 'Lexend', sans-serif;
    font-weight: 400;
    font-size: 24px;
    line-height: 30px;
    color: ${theme.palette.primary.main};
    text-transform: capitalize;
  }

  .info {
    padding-top: 34px;
    width: 101%;
    padding-bottom: 10px;
    position: sticky;
    top: 74px;
    background: ${theme.palette.customColor.white};
    z-index: 10;
  }

  .info-content {
      border-bottom: 1px solid ${theme.palette.customColor.secondaryThird};
      padding-bottom: 10px;
   }

  .button {
    margin-top: 42px;
  }
  `
  );

export default StyledProducts;
